import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll () {
    return store.dispatch('checkResponseApi', await Api().get('categories'))
  },

  async getSingle (data) {
    let param = 'category_id=' + data.category_id
    return store.dispatch('checkResponseApi', await Api().get('category?' + param))
  },

  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('category', data, options))
  },

  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('category', data, options))
  },

  async delete (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('category', { data: data }, options))
  },

}



// WEBPACK FOOTER //
// ./src/api/CategoryService.js